import { useState } from 'react';
import { supabase } from '../lib/supabase.js';

// หน้าตั้งรหัสผ่านจากลิงก์อีเมล (recovery link) — ระบบไม่เก็บ/ไม่แสดงรหัสผ่านที่ไหน
export default function SetPassword() {
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [msg, setMsg] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { setMsg('รหัสผ่านอย่างน้อย 8 ตัวอักษร'); return; }
    if (pw !== pw2) { setMsg('รหัสผ่านสองช่องไม่ตรงกัน'); return; }
    setBusy(true); setMsg('');
    const { error } = await supabase.auth.updateUser({ password: pw });
    if (error) setMsg(error.message);
    else { setDone(true); setMsg(''); }
    setBusy(false);
  };

  return (
    <div className="loginwrap">
      <div className="loginbox">
        <div className="lg"><img src="/logo-ink.svg" alt="" /><h1>ตั้งรหัสผ่าน</h1></div>
        <div className="sub">RentPoint · Camp Studio</div>
        {done ? (
          <>
            <div style={{ fontSize: 14, lineHeight: 1.6 }}>ตั้งรหัสผ่านเรียบร้อย — เข้าสู่ระบบด้วยรหัสใหม่ได้เลย</div>
            <button className="btn" style={{ marginTop: 20 }}
              onClick={() => { location.href = '/'; }}>ไปหน้าเข้าสู่ระบบ</button>
          </>
        ) : (
          <form onSubmit={submit}>
            <label>รหัสผ่านใหม่ (อย่างน้อย 8 ตัว)</label>
            <input type="password" value={pw} onChange={e => setPw(e.target.value)} autoFocus autoComplete="new-password" />
            <label>พิมพ์ซ้ำอีกครั้ง</label>
            <input type="password" value={pw2} onChange={e => setPw2(e.target.value)} autoComplete="new-password" />
            <button className="btn" disabled={busy}>บันทึกรหัสผ่าน</button>
          </form>
        )}
        {msg && <div className="err">{msg}</div>}
      </div>
    </div>
  );
}
